import NewPopularAccumulatorsCarousel from '@modules/sportOffer/popularAccumulators/NewPopularAccumulatorsCarousel.vue';
import MEBBBanner from '@sportOfferFederation/bet-builder/multi-event/components/MEBBBanner.vue';
import { ComponentConfig } from './shared';
import SportOfferCarousel from '@modules/sportOffer/sharedSubmodules/SportOfferCarousel.vue';
import HotTournamentsCarousel from '@modules/sportOffer/hotTournaments/HotTournamentsCarousel.vue';

export const SportsComponent = {
    MEBB_BANNER: 'MEBB_BANNER',
    TOP_EVENTS: 'TOP_EVENTS',
    POPULAR_SUPERBETS: 'POPULAR_SUPERBETS',
    HOT_TOURNAMENTS: 'HOT_TOURNAMENTS',
    POPULAR_ACCAS: 'POPULAR_ACCAS',
} as const;

export type SportsComponentKey = keyof typeof SportsComponent;

export type SportsComponentMap = {
    [SportsComponent.MEBB_BANNER]: ComponentConfig<typeof MEBBBanner>;
    [SportsComponent.TOP_EVENTS]: ComponentConfig<typeof SportOfferCarousel>;
    [SportsComponent.POPULAR_SUPERBETS]: ComponentConfig<typeof SportOfferCarousel>;
    [SportsComponent.HOT_TOURNAMENTS]: ComponentConfig<typeof HotTournamentsCarousel>;
    [SportsComponent.POPULAR_ACCAS]: ComponentConfig<typeof NewPopularAccumulatorsCarousel>;
};
